exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".POISelectorPicker {\r\n\tpadding: 10px;\r\n}\r\n\r\n.POISelectorPicker .MultiSelector {\r\n\twidth: 400px;\r\n}\r\n\r\n.POISelectorPicker .MultiSelector > label {\r\n\tcolor: #444;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/view/VehiclePOICrossings/POISelector/POISelector.css
// module id = 747
// module chunks = 0